<script setup lang="ts">
import { computed, defineAsyncComponent } from "vue";
import { useI18n } from "vue-i18n";

import FullModal from "@/dsComponents/modals/FullModal.vue";

const SendActiveProposition = defineAsyncComponent(
	() => import("@/modules/activeProposal/views/SendActiveProposition.vue")
);

interface SendActiveProposalModalProps {
    besoinId?: string;
    workerId?: string;
    jobId?: string;
    companyId?: string;
    onRefresh?: () => void | Promise<void>;
    onCancel?: () => void;
}

const props = defineProps<SendActiveProposalModalProps>();

const emit = defineEmits<(e: "close") => void>();

const { t } = useI18n();

const handleRefresh = async () => {
    await props.onRefresh?.();
    emit("close");
};

const handleClose = () => {
    props.onCancel?.();
    emit("close");
};

const modalTitle = computed(() => {
    return props.besoinId ? t("page.companyNeed.activeProposal.title") : t("page.activeProposition.send.title");
});
</script>

<template>
    <FullModal :title="modalTitle" @close="handleClose">
        <SendActiveProposition
            :besoinId="props.besoinId"
            :workerId="props.workerId"
            :jobId="props.jobId"
            :companyId="props.companyId"
            @refresh="handleRefresh"
        />
    </FullModal>
</template>

<style scoped lang="scss"></style>
